import client from '../../../core/services/client';

export const checkToken = (token) => client.get('recruit_participants', { params: { token } })
  .then((response) => response.data);

export const createRecruitToken = (token, firstName, lastName, userId) => client.post(
  'recruit_participants',
  {
    token,
    first_name: firstName,
    last_name: lastName,
    user_id: userId,
  },
).then((response) => response.data);
